import { useMemo } from 'react';

import { useCreditCardReceivablesNotification } from '@/features/notifications/hooks/useCreditCardReceivablesNotification';
import { useReferralsNotification } from '@/features/notifications/hooks/useReferralsNotification';
import { NotificationProps } from '@/features/notifications/types/NotificationProps';

export const useNotifications = (): Array<NotificationProps> => {
  const referrals = useReferralsNotification();
  const creditCardReceivables = useCreditCardReceivablesNotification();
  return useMemo(
    () => [referrals, creditCardReceivables].filter(Boolean),
    [creditCardReceivables, referrals]
  );
};
